// src/components/McpConnections/Spinner.js
import { CgSpinner } from 'react-icons/cg';

const Spinner = ({ size = '1.5rem' }) => {
  return <CgSpinner className="animate-spin" style={{ fontSize: size }} />;
};

export default Spinner;